import { render, staticRenderFns } from "./AnnouncementCreate.vue?vue&type=template&id=310b0dfd&scoped=true&"
import script from "./AnnouncementCreate.vue?vue&type=script&lang=js&"
export * from "./AnnouncementCreate.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementCreate.vue?vue&type=style&index=0&id=310b0dfd&prod&lang=scss&"
import style1 from "./AnnouncementCreate.vue?vue&type=style&index=1&id=310b0dfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b0dfd",
  null
  
)

export default component.exports